import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

class Bar extends Component {
  constructor(props) {
    super(props);
    this.state ={
      max: 0,
      name1: props.name1
    }
  }

  componentWillMount(){
    const c = this.state.name1;
    const max = Math.max.apply(Math,this.props.distribution.map(function(o){return o[`${c}`];}))
    this.setState({
        max: max
    });
  }

  sizeBox(size, total){
    const porc = (size / total) * 80;
    return `${Math.round(porc)}%`;
  }

  dateConvert(date){
    const dateConvert = moment(date).utc().format('DD-MM');
    return dateConvert ;
  }

  dateConvertYear(date){
    const dateConvert = moment(date).utc().format('DD-MM-YYYY');
    return dateConvert ;
  }

  render(){
    return(
      <div className={(this.props.line)?`main_summary_graphbar__color_item_container`:`main_summary_graphbar__color_item_container noline`}>
      {
        this.state.max > 0 &&
          this.props.distribution.map((item, i)=>(
            <div key={`barbh${i}`} className="main_summary_graphbar__color_item">
              <span className={(this.props.color)?item[this.props.color]:""} style={{height:this.sizeBox(item[this.props.name1],this.state.max)}}>
                <div className="main_summary_graph__color_hover">
                  {
                    (this.props.date)?(
                      <h4>
                      <strong className="text_graph">{this.dateConvertYear(item[this.props.name2])}</strong>
                      <strong>
                        {(this.props.tooltip)?this.props.tooltip.driver_behavior.title.driverSleeps:""}
                        {(item[this.props.name1])?item[this.props.name1].toFixed(2):0}
                       </strong>
                      </h4>
                    ):(
                     <h4>
                      <strong className="text_graph"></strong>
                      <strong>
                       {item[this.props.name1]} {(this.props.tooltip)?this.props.tooltip.driver_behavior.title.drivers:""} 
                      </strong>
                      </h4>
                    )
                  }
                </div>
              </span>
              {
                ((i % this.props.space ) == 0)?(
                  <h6><p>{(this.props.date)?this.dateConvert(item[this.props.name2]):item[this.props.name2]}</p></h6>
                ):(
                  <h6></h6>
                )
              }
            </div>
          ))
      }
      </div>
    );
  }
}

export default Bar;



// WEBPACK FOOTER //
// ./source/client/components/common/graphs/bar.jsx